// Якорные ссылки в мобильном меню 
export class BurgerAnchorLink {
    /**
     * Конструктор класса BurgerAnchorLink.
     *
     * @param {HTMLElement} link - Элемент ссылки.
     * @return {void} Эта функция ничего не возвращает.
     */
    constructor(link) {
        this.link = link;
        this.burgerMenu = link.closest(".js-burger-menu");
        this.followAnchorLink();
    }

    /**
     * Добавляет прослушиватель событий к элементу ссылки для обработки событий клика.
     *
     * @param {Event} event - Объект события.
     * @return {void} Нет возвращаемого значения.
     */
    followAnchorLink() {
        this.link.addEventListener("click", () => {
            this.burgerMenu.classList.remove("is-open");
            document.body.classList.remove("prevent-scroll");
        })
    }
}

document.querySelectorAll(".js-burger-anchor-link").forEach((link) => {
    new BurgerAnchorLink(link)
});
